import React from 'react';
import Paper from '@material-ui/core/Paper';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import pkg from '../../../package.json';

import styles from './styles';

export default function ErrorInfo({ message, info: { request = {} } }) {
  return <Paper className={styles.errorContainer} elevation={20}>

    <ErrorOutline className={styles.icon} />

    <h3>Ops! Algo não saiu do jeito que esperávamos!</h3>
    <p>
      O sistema não conseguiu carregar esta página. Isso pode ter ocorrido devido alguma
      indisponibilidade momentânea, problemas de conexão ou mesmo alguma lógica do sistema.
      Nós sugerimos que você <strong>tente novamente</strong> verificando os passos executados e, se
      o problema persistir, contate o suporte.
    </p>

    <p className={styles.rawErrorMessage}>
      { message }<br />
      &lt;{ request.status }, { request.statusText }&gt;
    </p>

    <p>
      Ao contatar o suporte informe os seguintes dados:
    </p>

    <h4>Informações</h4>

    <ul className={styles.infoList}>
      <li><strong>Aplicação:</strong> Perfil Securitário WEB ({ pkg.name })</li>
      <li><strong>Versão:</strong> { pkg.version }</li>
    </ul>
  </Paper>;
}
